// useAuth — replaces src/hooks/useAuth.js (Firebase version).
// Same return shape: { user, profile, loading, refreshProfile }
// All consumers (ProtectedRoute, TopBar, LeadDrawer, Profile page) unchanged.

import { useEffect, useState, useCallback } from 'react';
import { watchAuth, getProfile, ensureProfile } from '../lib/auth';

export function useAuth() {
  const [user, setUser]       = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshProfile = useCallback(async (u = user) => {
    if (!u) { setProfile(null); return; }
    const p = await getProfile(u.id);
    setProfile(p);
  }, [user]);

  useEffect(() => {
    const unsub = watchAuth(async (authUser) => {
      setUser(authUser);

      if (authUser) {
        try {
          const p = await ensureProfile(authUser);
          setProfile(p);
        } catch (e) {
          console.error('[useAuth] profile load failed:', e.message);
          setProfile(null);
        }
      } else {
        setProfile(null);
      }

      setLoading(false);
    });

    return unsub;
  }, []);

  return { user, profile, loading, refreshProfile };
}
